import type { ReportId } from "../config/reports-data"

/**
 * Persistent "the ready-to-reveal popover has already been shown" flags, keyed by
 * report id, in localStorage. The reveal popover (e.g. Love Match) is a
 * one-time moment: it appears the first time the finished report is tapped and
 * never again — including after a reload or a new session. Stored separately from
 * the sessionStorage unlock timer so it survives past that window.
 */
const STORAGE_KEY = "report-reveal-seen"

function readSeen(): Record<string, boolean> {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}") as Record<string, boolean>
  } catch {
    return {}
  }
}

/** True once the reveal popover for this report has already been shown. */
export function hasSeenReveal(reportId: ReportId): boolean {
  return readSeen()[reportId] === true
}

/** Record that the reveal popover for this report has been shown. */
export function markRevealSeen(reportId: ReportId): void {
  try {
    const seen = readSeen()
    seen[reportId] = true
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(seen))
  } catch {
    /* ignore */
  }
}
